import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil.js";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    data() {
        return {
            extending: {
                busy: false
            },
            printing: {
                busy: false
            }
        }
    },
    computed: {
    },
    methods: {
        async extendItem(id) {
            this.extending.busy = true;
            const response = await SingPauseApi.extendOGSEntry(this.id, id);
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Der ausgewählte Datensatz ${id} wurde korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Der ausgewählte Datensatz ${id} wurde nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        },
        async extendMultipleItems(ids) {
            this.extending.busy = true;
            const response = await SingPauseApi.extendMultipleOGSEntries(ids);
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Die ausgewählten Datensätze wurden korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Die ausgewählten Datensätze wurden nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        },
    }
};
